export default "__VITE_ASSET__CwAZCNvC__"